import './NotificationsTab.scss';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Tree } from 'primereact/tree';
import { Fragment, useMemo } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  getNotificationChannel,
  getNotificationRecipient,
  getNotificationType,
} from '../../../../../../../../utils/constants/entities/notifications';
import FieldWithErrors from '../../../../../../../Forms/ReactHookForm/FieldWithErrors';
import Tooltip from '../../../../../../../tooltip/Tooltip/Tooltip';
import { ckEditorConfig } from '../../../CreateEditDialog.functions';

function NotificationsTab({ defaultNotifications, smsGatewayOptions }) {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const notifications = useWatch({
    name: 'notification',
  });

  const pravno_lice = useWatch({
    name: 'pravno_lice',
  });

  const notificationType = useMemo(() => getNotificationType(t), [t]);
  const notificationChannel = useMemo(() => getNotificationChannel(t), [t]);
  const notificationRecipient = useMemo(() => getNotificationRecipient(t), [t]);

  const notificationTree = useMemo(() => {
    let tree = [
      {
        key: '-1',
        label: (
          <div className="notification-tree-column-container main">
            <div className="notification-tree-column">
              {t('Notification Type')}
            </div>
            <div className="notification-tree-column notification-info-column" />
            <div className="notification-tree-column">{t('Orderer Email')}</div>
            <div className="notification-tree-column">{t('Orderer SMS')}</div>
            <div className="notification-tree-column">{t('Sender Email')}</div>
            <div className="notification-tree-column">{t('Sender SMS')}</div>
            <div className="notification-tree-column">
              {t('Recipient Email')}
            </div>
            <div className="notification-tree-column">{t('Recipient SMS')}</div>
          </div>
        ),
      },
    ];

    for (let nType of notificationType) {
      let rootChildren = [];

      for (let nrType of notificationRecipient) {
        for (let nChannel of notificationChannel) {
          rootChildren?.push({
            key: `${nType.id}-${nrType.id}-${nChannel.id}`,
            label: `${nrType.title} ${nChannel.title}`,
            children: [
              {
                key: `${nType.id}-${nrType.id}-${nChannel.id}-0`,
                label:
                  nChannel.id === 1 ? (
                    <div style={{ width: '100%' }}>
                      <label
                        htmlFor={`notification.${nType.id}-${nrType.id}-${nChannel.id}.title`}
                      >
                        {t('Subject')}
                      </label>
                      <div className="p-fluid">
                        {/* <Field
                          as={InputText}
                          name={`notification.${nType.id}-${nrType.id}-${nChannel.id}.title`}
                          value={
                            notifications.notification[
                              `${nType.id}-${nrType.id}-${nChannel.id}`
                            ].title ??
                            defaultNotifications?.[
                              `${nType.id}-${nrType.id}-${nChannel.id}`
                            ]?.title
                          }
                          disabled={
                            !notifications.notification[
                              `${nType.id}-${nrType.id}-${nChannel.id}`
                            ].isChecked
                          }
                          className={`notification-${nType.id}-${nrType.id}-${nChannel.id}-subject`}
                        /> */}
                        <Controller
                          name={`notification.${nType.id}-${nrType.id}-${nChannel.id}.title`}
                          render={({ field }) => (
                            <InputText
                              id={`notification.${nType.id}-${nrType.id}-${nChannel.id}.title`}
                              name={`notification.${nType.id}-${nrType.id}-${nChannel.id}.title`}
                              value={
                                notifications[
                                  `${nType.id}-${nrType.id}-${nChannel.id}`
                                ].title ??
                                defaultNotifications?.[
                                  `${nType.id}-${nrType.id}-${nChannel.id}`
                                ]?.title
                              }
                              onChange={field.onChange}
                              disabled={
                                !notifications[
                                  `${nType.id}-${nrType.id}-${nChannel.id}`
                                ].isChecked
                              }
                              className={`notification-${nType.id}-${nrType.id}-${nChannel.id}-subject`}
                            />
                          )}
                        />
                      </div>

                      <label
                        style={{
                          display: 'block',
                          marginTop: 8,
                        }}
                      >
                        {t('Body')}
                      </label>
                      <CKEditor
                        editor={ClassicEditor}
                        config={ckEditorConfig}
                        data={
                          notifications[
                            `${nType.id}-${nrType.id}-${nChannel.id}`
                          ]?.message ??
                          defaultNotifications?.[
                            `${nType.id}-${nrType.id}-${nChannel.id}`
                          ]?.message
                        }
                        disabled={
                          !notifications[
                            `${nType.id}-${nrType.id}-${nChannel.id}`
                          ]?.isChecked
                        }
                        onBlur={(_, editor) =>
                          setValue(
                            `notification.${nType.id}-${nrType.id}-${nChannel.id}.message`,
                            editor.getData(),
                            false
                          )
                        }
                      />
                    </div>
                  ) : (
                    <div style={{ width: '100%' }}>
                      <label
                        htmlFor={`notification.${nType.id}-${nrType.id}-${nChannel.id}.message`}
                      >
                        {t('Message')}
                      </label>
                      <br />
                      {/* <Field
                        as={InputTextarea}
                        name={`notification.${nType.id}-${nrType.id}-${nChannel.id}.message`}
                        value={
                          notifications?.notification[
                            `${nType.id}-${nrType.id}-${nChannel.id}`
                          ]?.message !== null
                            ? notifications?.notification[
                                `${nType.id}-${nrType.id}-${nChannel.id}`
                              ]?.message
                            : defaultNotifications?.[
                                `${nType.id}-${nrType.id}-${nChannel.id}`
                              ]?.message
                        }
                        disabled={
                          !notifications?.notification[
                            `${nType.id}-${nrType.id}-${nChannel.id}`
                          ]?.isChecked
                        }
                      /> */}
                      <Controller
                        name={`notification.${nType.id}-${nrType.id}-${nChannel.id}.message`}
                        render={({ field }) => (
                          <InputTextarea
                            id={`notification.${nType.id}-${nrType.id}-${nChannel.id}.message`}
                            name={`notification.${nType.id}-${nrType.id}-${nChannel.id}.message`}
                            value={
                              notifications[
                                `${nType.id}-${nrType.id}-${nChannel.id}`
                              ].message ??
                              defaultNotifications?.[
                                `${nType.id}-${nrType.id}-${nChannel.id}`
                              ]?.message
                            }
                            onChange={field.onChange}
                            disabled={
                              !notifications[
                                `${nType.id}-${nrType.id}-${nChannel.id}`
                              ].isChecked
                            }
                            // className={`notification-${nType.id}-${nrType.id}-${nChannel.id}-subject`}
                          />
                        )}
                      />
                    </div>
                  ),
              },
              {
                key: `${nType.id}-${nrType.id}-${nChannel.id}-0-placeholders`,
                label: t('Available placeholders'),
                children: [
                  {
                    key: `${nType.id}-${nrType.id}-${nChannel.id}-0-placeholder-list`,
                    label: (
                      <div className="placeholder-list">
                        {/* {defaultNotifications?.[
                          `${nType.id}-${nrType.id}-${nChannel.id}`
                        ]?.placeholders?.map((p, i) => (
                          <Fragment key={i}>
                            {p}
                            <br />
                          </Fragment>
                        ))} */}
                        {Array.isArray(
                          defaultNotifications?.[
                            `${nType.id}-${nrType.id}-${nChannel.id}`
                          ]?.placeholders
                        ) &&
                          defaultNotifications[
                            `${nType.id}-${nrType.id}-${nChannel.id}`
                          ].placeholders.map((p, i) => (
                            <Fragment key={i}>
                              {p}
                              <br />
                            </Fragment>
                          ))}
                      </div>
                    ),
                  },
                ],
              },
            ],
          });
        }
      }

      const label = (
        <div className="notification-tree-column-container">
          <div className="notification-tree-column">{nType?.title}</div>
          <div className="notification-tree-column notification-info-column">
            <Tooltip text={nType?.description}>
              <span className="notification-info-icon">
                <FontAwesomeIcon icon={faInfoCircle} />
              </span>
            </Tooltip>
          </div>

          {notificationRecipient?.map((nrType) =>
            notificationChannel?.map((nChannel) => (
              <div
                key={`${nType.id}-${nrType.id}-${nChannel.id}`}
                className="notification-tree-column"
              >
                {/* <Field
                  as={Checkbox}
                  name={`notification.${nType.id}-${nrType.id}-${nChannel.id}.isChecked`}
                  checked={
                    notifications?.notification[
                      `${nType.id}-${nrType.id}-${nChannel.id}`
                    ]?.isChecked
                  }
                  className={`notification-${nType.id}-${nrType.id}-${nChannel.id}-checkbox`}
                /> */}
                <Controller
                  name={`notification.${nType.id}-${nrType.id}-${nChannel.id}.isChecked`}
                  render={({ field }) => (
                    <Checkbox
                      id={`notification.${nType.id}-${nrType.id}-${nChannel.id}.isChecked`}
                      name={`notification.${nType.id}-${nrType.id}-${nChannel.id}.isChecked`}
                      checked={
                        notifications[`${nType.id}-${nrType.id}-${nChannel.id}`]
                          ?.isChecked
                      }
                      //  checked={!!values.interen_klient}
                      onChange={field.onChange}
                      className={`notification-${nType.id}-${nrType.id}-${nChannel.id}-checkbox`}
                    />
                  )}
                />
              </div>
            ))
          )}
        </div>
      );

      tree.push({
        key: nType.id,
        label,
        children: rootChildren,
      });
    }

    return tree;
  }, [
    defaultNotifications,
    notificationChannel,
    notificationRecipient,
    notificationType,
    setValue,
    t,
    notifications,
  ]);

  return (
    <div className="notifications-tab p-fluid">
      <FieldWithErrors name="sms_gateway" label={t('SMS Provider')}>
        <Controller
          name="sms_gateway"
          render={({ field }) => (
            <Dropdown
              id="sms_gateway"
              name="sms_gateway"
              options={smsGatewayOptions}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </FieldWithErrors>
      <div className="notification-tab-checkbox-field">
        {pravno_lice && (
          <FieldWithErrors
            name="import_notification"
            label={false}
            className="p-d-flex p-mb-2 p-jc-between"
          >
            <Controller
              name="import_notification"
              render={({ field }) => (
                <>
                  <Checkbox
                    id="import_notification"
                    name="import_notification"
                    checked={field.value}
                    value={field.value}
                    onChange={field.onChange}
                  />
                  <label
                    htmlFor="import_notification"
                    data-cy="import_notification"
                  >
                    {t('Receive import notifications')}
                  </label>
                </>
              )}
            />
          </FieldWithErrors>
        )}
      </div>

      <span className="dialog-section-divider">
        {t('Subscription settings')}
      </span>

      <p className="notification-settings-info">
        {t(
          'Each message can contain placeholders, which represent dynamic text.'
        )}
        &nbsp;
        {t('They are placed inside { and }.')}
        <br />
        {t(
          'Available placeholders can be found inside the expandable section in the message you are editing.'
        )}
      </p>

      <Tree value={notificationTree} style={{ width: '100%' }} />
    </div>
  );
}

export default NotificationsTab;
